// src/components/course/CourseContentGridSkeleton.js
import React from 'react';
import WordCardSkeleton from './WordCardSkeleton';
import SentenceCardSkeleton from './SentenceCardSkeleton';
import { useTranslation } from '../../../hooks/useTranslation'; // MODIFIED: Import hook

// This is the Grid wrapper from ItemGrid.js, matching the exact structure
const Grid = ({ contentType, children }) => {
  const gridClasses =
    contentType === 'words'
      ? 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6'
      : 'grid-cols-1 sm:grid-cols-2 xl:grid-cols-3';

  return <div className={`grid gap-1 sm:gap-4 pt-2 ${gridClasses}`}>{children}</div>;
};

const CourseContentGridSkeleton = ({ contentType = 'words' }) => {
  // MODIFIED: Get the translation state
  const [showTranslation] = useTranslation();
  const itemsPerPage = contentType === 'words' ? 18 : 12;

  return (
    <Grid contentType={contentType}>
      {Array.from({ length: itemsPerPage }).map((_, index) => (
        <div key={index} className="p-0.5 sm:p-1">
          {contentType === 'words' ? (
            // MODIFIED: Pass prop to skeleton
            <WordCardSkeleton showTranslation={showTranslation} />
          ) : (
            // MODIFIED: Pass prop to skeleton
            <SentenceCardSkeleton showTranslation={showTranslation} />
          )}
        </div>
      ))}
    </Grid>
  );
};

export default CourseContentGridSkeleton;
